import { createFileRoute } from '@tanstack/react-router'
import { ElasticPage } from '@features/admin/elastic'

export const Route = createFileRoute('/admin/elastic')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ElasticPage />
}
